import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedUiCommonModule } from "@kno2/common/components";
import { TopnavComponent } from "./topnav.component";

@NgModule({
    imports: [CommonModule, SharedUiCommonModule],
    declarations: [TopnavComponent],
    exports: [TopnavComponent]
})
export class DesktopFeatureCommonTopnavModule {}
